<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  components: {}
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

img {
  width: 100%;
  height: 100%;
}

</style>
